let ActiveUrlClassSetter = function (el) {
    this.el = el;
    this.$el = $(el);
    this.$anchors = this.$el.find('a');
    this.className = this.$el.data('activeclass') || 'activeTest';
    this.homeSelector = this.$el.data('homeselector') || '';

    this.attachClasses();
};

ActiveUrlClassSetter.prototype.attachClasses = function () {
    let activeUrl = window.location.pathname;

    if ($.inArray(activeUrl, ['/', '/en/', '/index.php']) > -1) {
        if (this.homeSelector !== '')
            $(this.homeSelector).addClass(this.className);
    } else {
        this.$anchors.each(function (index, anchor) {
            let $anchor = $(anchor);
            let anchorUrl = anchor.href;
            let isAnchorActive = anchorUrl.indexOf(activeUrl) > -1;

            if (isAnchorActive) {
                $anchor.addClass(this.className);
                $anchor.parentsUntil(this.el).addClass(this.className);
            }
        }.bind(this));
    }

    return this;
};

export default ActiveUrlClassSetter;
